export const destinations = [
  {
    id: 1,
    name: "Santorini, Greece",
    tagline: "Iconic sunsets & whitewashed villages",
    image: "https://readdy.ai/api/search-image?query=Santorini%20Greece%20stunning%20white%20buildings%20blue%20domes%20cliffside%20overlooking%20turquoise%20Aegean%20sea%20golden%20sunset%20dramatic%20sky%20vibrant%20colors&width=600&height=400&seq=dest1&orientation=landscape",
    category: "Europe",
    rating: 4.9,
    reviews: 1240,
    price: 1299,
    highlights: ["Oia Sunset", "Caldera Views", "Wine Tasting", "Boat Tours"],
    lat: 36.3932,
    lng: 25.4615,
  },
  {
    id: 2,
    name: "Bali, Indonesia",
    tagline: "Tropical paradise of temples & rice terraces",
    image: "https://readdy.ai/api/search-image?query=Bali%20Indonesia%20lush%20green%20rice%20terraces%20tropical%20jungle%20temple%20ancient%20stone%20carvings%20vibrant%20flowers%20warm%20golden%20light%20exotic%20paradise&width=600&height=400&seq=dest2&orientation=landscape",
    category: "Asia",
    rating: 4.8,
    reviews: 2180,
    price: 899,
    highlights: ["Ubud Temples", "Rice Terraces", "Surf Lessons", "Spa Retreats"],
    lat: -8.3405,
    lng: 115.0920,
  },
  {
    id: 3,
    name: "Machu Picchu, Peru",
    tagline: "Ancient Incan citadel in the clouds",
    image: "https://readdy.ai/api/search-image?query=Machu%20Picchu%20Peru%20ancient%20Incan%20ruins%20dramatic%20mountain%20peaks%20misty%20clouds%20lush%20green%20terraces%20dramatic%20landscape%20mystical%20atmosphere&width=600&height=400&seq=dest3&orientation=landscape",
    category: "South America",
    rating: 4.9,
    reviews: 980,
    price: 1599,
    highlights: ["Inca Trail", "Sun Gate", "Llama Encounters", "Aguas Calientes"],
    lat: -13.1631,
    lng: -72.5450,
  },
  {
    id: 4,
    name: "Safari, Kenya",
    tagline: "Witness the great migration up close",
    image: "https://readdy.ai/api/search-image?query=Kenya%20Africa%20safari%20savanna%20golden%20grass%20elephants%20lions%20giraffes%20dramatic%20sunset%20orange%20sky%20wildlife%20adventure%20vast%20plains&width=600&height=400&seq=dest4&orientation=landscape",
    category: "Africa",
    rating: 4.9,
    reviews: 760,
    price: 2199,
    highlights: ["Big Five Safari", "Masai Mara", "Hot Air Balloon", "Tribal Culture"],
    lat: -1.2921,
    lng: 36.8219,
  },
  {
    id: 5,
    name: "Kyoto, Japan",
    tagline: "Ancient temples meet cherry blossom magic",
    image: "https://readdy.ai/api/search-image?query=Kyoto%20Japan%20cherry%20blossom%20sakura%20ancient%20temple%20pagoda%20traditional%20architecture%20pink%20flowers%20serene%20garden%20peaceful%20spring%20atmosphere&width=600&height=400&seq=dest5&orientation=landscape",
    category: "Asia",
    rating: 4.8,
    reviews: 1560,
    price: 1099,
    highlights: ["Fushimi Inari", "Arashiyama Bamboo", "Tea Ceremony", "Geisha District"],
    lat: 35.0116,
    lng: 135.7681,
  },
  {
    id: 6,
    name: "Amalfi Coast, Italy",
    tagline: "Dramatic cliffs, azure waters & Italian charm",
    image: "https://readdy.ai/api/search-image?query=Amalfi%20Coast%20Italy%20dramatic%20cliffs%20colorful%20villages%20perched%20on%20hillside%20turquoise%20Mediterranean%20sea%20lemon%20groves%20vibrant%20summer%20atmosphere&width=600&height=400&seq=dest6&orientation=landscape",
    category: "Europe",
    rating: 4.7,
    reviews: 1890,
    price: 1399,
    highlights: ["Positano", "Ravello Gardens", "Boat Excursions", "Limoncello Tasting"],
    lat: 40.6340,
    lng: 14.6027,
  },
  {
    id: 7,
    name: "Maldives",
    tagline: "Overwater bungalows in crystal clear lagoons",
    image: "https://readdy.ai/api/search-image?query=Maldives%20overwater%20bungalows%20crystal%20clear%20turquoise%20lagoon%20white%20sand%20beach%20tropical%20paradise%20luxury%20resort%20stunning%20aerial%20view&width=600&height=400&seq=dest7&orientation=landscape",
    category: "Asia",
    rating: 5.0,
    reviews: 2340,
    price: 2899,
    highlights: ["Overwater Villas", "Snorkeling", "Dolphin Cruises", "Sunset Dining"],
    lat: 3.2028,
    lng: 73.2207,
  },
  {
    id: 8,
    name: "Patagonia, Argentina",
    tagline: "Raw wilderness at the end of the world",
    image: "https://readdy.ai/api/search-image?query=Patagonia%20Argentina%20dramatic%20mountain%20peaks%20glaciers%20turquoise%20lakes%20wild%20landscape%20Torres%20del%20Paine%20dramatic%20clouds%20adventure%20trekking&width=600&height=400&seq=dest8&orientation=landscape",
    category: "South America",
    rating: 4.8,
    reviews: 540,
    price: 1799,
    highlights: ["Torres del Paine", "Perito Moreno Glacier", "Condor Watching", "Gaucho Culture"],
    lat: -51.6230,
    lng: -69.2168,
  },
];

export const categories = ["All", "Europe", "Asia", "Africa", "South America"];
